export default (function ($) {
  'use strict';

  // Set hero-slider container height to eliminate weird spaces underneath it at certain screen sizes.
  function setSlideContainerHeight () {
    let currentSlideInner = $('#hero-slider div.slick-slide.slick-current.slick-active div.js-slide-inner');

    if (currentSlideInner) {
      $('#hero-slider').height(currentSlideInner.css( "height" ));
    }
  }

  $(document).ready(function () {
    $('#hero-slider').slick({
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: false,
      prevArrow: null,
      nextArrow: null,
    });

    // Make the next button work.
    $('.js-next').on('click', function () {
      $('#hero-slider').slick('slickNext');
    });

    // Focus the next button of the active slide after each slide change to
    // improve keyboard navigability.
    $('#hero-slider').on('afterChange', function (event, slick, currentSlide, nextSlide) {
      event.target
      .querySelector('.slick-active')
      .querySelector('.js-next')
      .focus();
    });

    if ($('#hero-slider').length) {
      setSlideContainerHeight();

      window.addEventListener('resize', function () {
        setSlideContainerHeight();
      });
    }
  });
})(jQuery);



// WEBPACK FOOTER //
// ./resources/js/hero-slider.js